<template id="salesman-compare">
  <section>
    <div class="card m-1"
         :class="this.$store.state.bannerStatus ? 'card-true' : 'card-false'">
      <div class="card-header">
            <span class="float-left">
                 <div class="d-flex">
                    <div class="mr-auto ">
                        <b>{{ screenName }} </b>
                    </div>

              <span v-for="(key,l) of screenListboxDim" :key="'S'+l">
               <div class="mr-auto ">
                   <span class="anyWhichWayS" v-if="screenListboxType=='anyWhichWay'">{{ SlistboxDimBizName[l] }}:
                     <!--                   <select style="width: 100px;" v-model="x[key]" @change="loadSummary()">
                                             <option value="All">All</option>
                                             <option v-for="k of getValues(key,x)" :key="k" :value="k">{{k}}</option>
                                         </select>-->
                   <v-select multiple v-model="x[key]" @input="loadSummary()" :options="getValues(key,x)"
                             :close-on-select="false">
                    </v-select>
                   </span>
               </div>
                   </span>



                   <span v-for="(key,l) of screenListboxDim" :key="'F'+l">
               <div class="mr-auto">
                   <span class="freeFormS" v-if="screenListboxType=='freeForm'">{{ SlistboxDimBizName[l] }}:
                     <!--<select style="width: 100px;" v-model="x[key]" @change="loadSummary()">
                          <option value="All">All</option>
                          <option v-for="k of getFilteredValues(key)" :key="k" :value="k">{{k}}</option>
                      </select>-->
                   <v-select multiple v-model="x[key]" @input="loadSummary()" :options="getFilteredValues(key)"
                             :close-on-select="false">
                   </v-select>
                   </span>
               </div>
                   </span>


                 </div>
            </span>
        <div class="d-flex justify-content-end ">
          <!-- <div class="p-2"><i class="fa fa-lg fa-comments" title="Add your comment"></i></div>
           <div class="p-2"><i class="fa fa-download" title="Download"></i></div>
           <div class="p-2"><i class="fa fa-share" title="Share"></i></div>
           &lt;!&ndash; <div class="p-2"> <i class="fas fa-minus" @click="decrementValue"></i></div>&ndash;&gt;
           <div class="p-2"><i class="fas fa-plus" title="Add a screenlet" @click="incrementValue"></i></div>
           &lt;!&ndash;<div class="p-2"><i class="fas fa-redo" @click="resetValue"></i></div>&ndash;&gt;
           <div class="p-2">{{counter}}</div>-->
          <div class="float-right">

            <i v-for="(ai,index) in currentMenuActionIconsData" :key="index"
               v-bind:class="ai.iconClass" :title="ai.iconTooltip" style="font-size:15px; padding-left:10px;">
            </i>
          </div>
        </div>
      </div>
      <div v-if="distinctScreenlet.length==1" v-bind:class="screenCardStyle=='card-deck'?'card-deck':''">
        <div class="card" v-for="i in counter" v-bind:key="i">
          <entity-dashboard :scrnPropTime="scrnPropTime" :screenlet="i" :screenletId="distinctScreenlet[0]"
                            :sl="x"></entity-dashboard>
        </div>
      </div>
      <div v-else-if="screenCardStyle==='vertical-card-deck'"
           v-bind:class="screenCardStyle=='vertical-card-deck'?'card-deck':''">
        <!--        <div v-for="scrlet in distinctScreenlet" v-bind:key="scrlet">{{scrlet}}</div>-->
        <div class="card" v-for="scrlet in distinctScreenlet" v-bind:key="scrlet">
          <entity-dashboard :scrnPropTime="scrnPropTime" :screenlet="scrlet" :screenletId="scrlet"
                            :sl="x"></entity-dashboard>
        </div>

      </div>
      <div v-else v-bind:class="screenCardStyle=='card-deck'?'card-deck':''">
        <!--        <div v-for="scrlet in distinctScreenlet" v-bind:key="scrlet">{{scrlet}}</div>-->
        <entity-dashboard v-for="scrlet in distinctScreenlet" v-bind:key="scrlet" :scrnPropTime="scrnPropTime"
                          :screenlet="scrlet" :screenletId="scrlet" :sl="x"></entity-dashboard>
      </div>
    </div>
  </section>
</template>
<script>

import entityDashboard from '@/components/screenlet_seq_test_2'
import _ from 'lodash'
// import { bus } from '@/bus'
import axios from 'axios'

export default {
  name: 'salesman-compare',
  components: {entityDashboard},
  data: () => ({
    counter: null,
    screenletMaxCount: null,
    screenletAdditionFlag: null,
    scrnPropTime: null,
    optionValues: ['a', 'b'],
    screenName: '',
    x: {},//need to revisit to make it dynamic
    y: {},
    li: 0,
    screenListboxCount: null,
    orderbyTextJson: {},
    screenListboxDim: {},
    dateRangeFilterFlag: '',
    SlistboxDimBizName: {},
    currentMenuActionIconsData: {},
    currentMenuListboxData: {},
    dateRangeFilterShortcuts: {},
    shortcuts: [],
    temp: [],
    promises: [],
    rowColMap: {},
    screenListboxType: null,
    example: [],
    screenListboxDefault: {},
    screenCardStyle: '',
    distinctScreenlet: []
  }),
  computed: {
    getValues() {
      return (key1, x) => {
        // console.log("getValues ====> item", key1, x)
        var filteredData = this.example.filter((item) => {

          for (let kkk in x) { // loop over the keys of x
            //console.log("getValues >>>> ",kkk)

            if (x[kkk] && x[kkk].length > 0) { //check the value of each key is undefined/NULL or not
              //  console.log("getValues ,,,,",x[kkk],x[kkk].includes("All"))

              if (!x[kkk].includes('All')) { // check the value of the key doesn't contains All as a value
                // console.log("getValues,,,,", item[kkk], x[kkk])
                if (item[kkk] === undefined || !x[kkk].includes(item[kkk])) {

                  return false
                }
              }
            }
            //  console.log("not entered if")
          }
          return true
        })

        var whereClause = '1==1 '
        for (let kkk in x) {
          // console.log("kkk x ",kkk, x,x[kkk],whereClause + ' && ! x[kkk]'+ '.includes("item["' + kkk + '"]) ')
          if (x[kkk] && x[kkk].length > 0 && x[key1] && x[key1].length > 0) { //check the value of each key is undefined/NULL or not
            if (kkk == key1) { // check if it is for the passed key then make it as not in
              whereClause = whereClause + ' && !x["' + kkk + '"]' + '.includes(item["' + kkk + '"]) '
            } else { //if not append and clause
              whereClause = whereClause + ' && x["' + kkk + '"]' + '.includes(item["' + kkk + '"])'
            }

          } else if (x[key1] && x[key1].length <= 0) {
            whereClause = whereClause + ' && 1==2 '
          }
        }
        var example1 = _.clone(this.example)

        var invertFilteredData = example1.filter((item) => {

          if (eval(whereClause) && item) {
            return true
          } else {
            return false
          }

        })
        var firstArray = _.uniq(filteredData.map(kv => kv[key1]))
        var secondArray = []
        if (x[key1] && x[key1].length > 0) {
          secondArray = _.uniq(invertFilteredData.map(kv => kv[key1]))
        }

        var unionArray = _.union(firstArray, secondArray)
        console.log('where clause', whereClause, x, key1, secondArray, invertFilteredData)
        return unionArray.sort() //gets the unique values from the filteredData by mapping the passed key and sort the values in ascending order
      }

      //console.log("getValues -->",_.uniq(this.example.map(kv => kv[key])),k)
      //return _.uniq(this.example.map(kv => kv[key]))
      /*if(k) {
          console.log("getValues with k selected",_.uniq(this.example.filter(kv => kv[key] === k).map(kv => kv[key])))
          return _.uniq(this.example.filter(kv => kv[key] === k).map(kv => kv[key]))
      }
      else if(k=='All'){
          console.log("getValues with All selected",_.uniq(this.example.map(kv => kv[key])))
          return _.uniq(this.example.map(kv => kv[key]))
      }
      else {
          console.log("getValues with default",_.uniq(this.example.map(kv => kv[key])))
          return _.uniq(this.example.map(kv => kv[key]))
      }*/
    },
    getFilteredValues() {
      return (key1) => {
        return _.uniq(this.example.map(kv => kv[key1])).sort()
      }

    },


  },
  created() {
    this.screenRender()
    this.listenToRouter()
    this.loadListbox()
    this.loadSummary()
  },
  methods: {
    incrementValue() {
      this.counter++
    },
    decrementValue() {
      this.counter--
    },
    resetValue() {
      this.counter = 0
    },
    screenRender: function () {
      let submenuParam = this.$route.params.submenuId
      console.log('scr', 'load state')
      this.$store.dispatch('loadState').then(() => {
        let allMenuScreenData = this.$store.state.fwConfigMenuScreenRender
        console.log('Menu Screen Data', allMenuScreenData)
        let menuScreenData = allMenuScreenData.filter(r => r.menuId === submenuParam)
        this.counter = menuScreenData[0].screenletDefaultCount
        this.screenletMaxCount = menuScreenData.screenletMaxCount
        this.screenletAdditionFlag = menuScreenData.screenletAdditionFlag
        this.distinctScreenlet = [...new Set(menuScreenData.map(item => item.screenletInstanceId))]
        console.log("Distinct screenlet", this.distinctScreenlet)
        console.log('screenlet Param', this.counter, this.screenletMaxCount, this.screenletAdditionFlag)
      })
    },
    fetchListboxData: function (sqlId) {
      return axios.get('/api/fetchListboxData/' + sqlId).then(res => {
        //console.log("Loop increment value inside api",index);
        console.log('Load salesman called with', sqlId)
        let resData = res.data
        this.example = resData
        //convert set of values into an array using array.from
        //this.optionValues[index] = Array.from(new Set(resData.map(c => c.dim1).filter(x => x != null)))
        let temp = Array.from(new Set(resData.map(c => c.dim1).filter(x => x != null)))
        console.log('Salesman data option values:', resData, temp)
        //return temp
      }, err => {
        console.log('Error in fetching record', err)
      })
    },
    loadListbox: function () {
      let submenuParam = this.$route.params.submenuId
      console.log('scr-2', 'load state')
      this.$store.dispatch('loadState').then(() => {
        this.screenName = this.$store.state.menuMasterFlat.filter(m => m.menuId === submenuParam).map(m => m.menuName)[0]
        let menuData = this.$store.state.fwConfigMenuScreenRender
        let columnMetadata = this.$store.state.colummnMetaData
        let actionIconsData = this.$store.state.actionIcons
        let listboxData = this.$store.state.listbox
        console.log('menu screen Data', menuData)
        console.log('column Meta Data', columnMetadata)
        console.log('Action Icons Data', actionIconsData)
        console.log('Listbox Data', listboxData)
        let currentMenuData = menuData.filter(r => r.menuId === submenuParam)
        // ?? checking null value and assigning empty array since models.kt returns null instead of empty list
        var screenActionIconsSyspkArray = currentMenuData[0].screenActionIconsSyspkArray ? currentMenuData[0].screenActionIconsSyspkArray : []
        var screenListboxSyspkArray = currentMenuData[0].screenListboxSyspkArray ? currentMenuData[0].screenListboxSyspkArray : []
        console.log('Syspk whether null or not', screenListboxSyspkArray)
        var currentMenuActionIconsData = actionIconsData.filter(r => screenActionIconsSyspkArray.includes(r.syspk))
        var currentMenuListboxData = listboxData.filter(r => screenListboxSyspkArray.includes(r.syspk))

        this.screenListboxDefault = currentMenuData[0].screenListboxDefaultValue
        this.screenCardStyle = currentMenuData[0].screenCardStyle
        console.log("Screen Listbox default value", this.screenListboxDefault, this.screenCardStyle)
        if (this.screenListboxDefault != null) {
          if (Object.keys(this.screenListboxDefault).length > 0) {
            Object.keys(this.screenListboxDefault).forEach((k) => {
              this.x[k] = this.screenListboxDefault[k];
              console.log("Key and value of default LB", k, this.screenListboxDefault[k])
            })
          }
        }


        // sort function for sorting the filtered currentMenuListboxData with the reference Array screenListboxSyspkArray
        function sortFuncLB(a, b) {
          // console.log("test sort ", a,b)
          return screenListboxSyspkArray.indexOf(a.syspk) - screenListboxSyspkArray.indexOf(b.syspk)
        }

        // sort function for sorting the filtered currentMenuActionIconsData with the reference Array screenActionIconsSyspkArray
        function sortFuncAI(a, b) {
          // console.log("test sort ", a,b)
          return screenActionIconsSyspkArray.indexOf(a.syspk) - screenActionIconsSyspkArray.indexOf(b.syspk)
        }

        currentMenuListboxData.sort(sortFuncLB) //sorting the currentMenuListboxData
        currentMenuActionIconsData.sort(sortFuncAI) //sorting the currentMenuActionIconsData

        this.currentMenuActionIconsData = currentMenuActionIconsData //need to add in router function
        this.currentMenuListboxData = currentMenuListboxData
        this.screenListboxCount = currentMenuListboxData.length
        this.dateRangeFilterFlag = currentMenuData[0].dateRangeFilterDisplayFlag
        this.dateRangeFilterShortcuts = currentMenuData[0].dateRangeFilterShortcuts
        this.orderbyTextJson = currentMenuData[0].orderbyTextJson
        var currentMenuListboxSQLId = currentMenuData[0].screenListbox1_sqlId
        this.screenListboxType = currentMenuData[0].screenListboxType
        if (currentMenuListboxSQLId) {
          this.fetchListboxData(currentMenuListboxSQLId)
        }

        console.log('Current Menu data', currentMenuData[0].dateRangeFilterShortcuts, this.dateRangeFilterShortcuts)
        console.log('S Action Icon array', currentMenuActionIconsData, screenActionIconsSyspkArray, currentMenuListboxData, currentMenuData[0].dateRangeFilterDisplayFlag, this.orderbyTextJson)

        function dateRangeCalc(date1, interval, dateType) {
          switch (dateType) {
            case 'month': {
              //var date1 = new Date();
              var firstDay = new Date(date1.getFullYear(), date1.getMonth() - interval, 1)
              var lastDay = new Date(date1.getFullYear(), date1.getMonth(), 0)
              const date = [firstDay, lastDay]
              //console.log("Dates :",start,end,date);
              return date
            }
            case 'day': {
              firstDay = new Date()
              var dateOffset = (24 * 60 * 60 * 1000) * interval //5 days
              lastDay = new Date()
              firstDay.setTime(firstDay.getTime() - dateOffset)
              lastDay.setTime(lastDay.getTime())
              const date = [firstDay, lastDay]
              //console.log("Dates :",start,end,date);
              return date
            }
            case 'hour': {
              firstDay = new Date()
              dateOffset = (interval * 60 * 60 * 1000) //5 days
              lastDay = new Date()
              firstDay.setTime(firstDay.getTime() - dateOffset)
              lastDay.setTime(lastDay.getTime())
              const date = [firstDay, lastDay]
              //console.log("Dates :",start,end,date);
              return date
            }
          }
        }

        //let shortcuts = []
        for (let key in this.dateRangeFilterShortcuts) {
          let value = this.dateRangeFilterShortcuts[key]
          console.log('for key', key, value)
          //var shortcut = {'text':key}
          for (let inKey in value) {
            console.log('for keys', key, inKey, value[inKey])
            var shortcut = {
              'text': key,
              onClick() {
                let date2 = dateRangeCalc(new Date(), value[inKey], inKey)
                console.log('Previous month start and end', date2)
                //const start= new Date();
                //const end= new Date(start.getTime() - 3600 * 1000 * 24*7)
                return date2
              }
            }
            console.log('Shortcut ', shortcut)
            this.shortcuts.push(shortcut)
          }
        }

        currentMenuListboxData.forEach((cmld, index) => {
          //console.log("Test object",cmld.listboxDimName, index); // the name of the current key.
          //console.log("Test object",cmld.listboxDimName, cmld.listboxSqlId); // the value of the current key.
          this.screenListboxDim[index] = cmld.listboxDimName
          let bizNamefilterdim = columnMetadata.filter(c => c.columnName === cmld.listboxDimName)
          this.SlistboxDimBizName[index] = bizNamefilterdim[0].bizName
          //this.x[cmld.listboxDimName]="All"
        })
        console.log('Listbox data', this.screenListboxDim)
        /*        // Function to fetch listbox data for the passed Listbox SQLID

                const fetchGithubInfo = async (url) => {
                  console.log(`Fetching ${url}`,url)
                  const githubInfo = await axios(url) // API call to get listbox data for the Listbox SQLID.

                  return {
                    data1: Array.from(new Set(githubInfo.data.map(c => c.dim1).filter(x => x != null)))
                  }
                }

                // Iterates all listbox dimensions and returns their Listbox SQLID info.
                const fetchUserInfo = async (cmld) => {
                  const requests = cmld.map((ld) => {
                    const url = `/api/fetchListboxData/${ld.listboxSqlId}`
                    return fetchGithubInfo(url) // Async function that fetches the listbox data.
                     .then((a) => {
                        return  a // Returns the listbox data info.
                      })
                  })
                  return Promise.all(requests) // Waiting for all the requests to get resolved.
                }

                fetchUserInfo(currentMenuListboxData)
                 .then(a => { this.optionValues = a
                   // console.log(a[0])
                 })
                 //   console.log("Salesman data option values outside:",this.optionValues,this.screenListboxDim[1],this.optionValues[0])*/
      })
    },
    loadSummary: function () {
      this.scrnPropTime = new Date()
      /*  let submenuParam = this.$route.params.submenuId
        this.$store.dispatch("loadState").then(() => {
            let allVizData = this.$store.state.fwConfigScreenElement


            let vizData = allVizData.filter(r => r.menuId === submenuParam)
            console.log("Visualization Data", vizData)
            if (vizData.length === 0) {
                console.error("No vizdata for the screen, hence Blank Screen..fix data", vizData, vizData.length)
                return
            }
            console.log('Testing Passed Parameter for selecttttt', x)  //for passing paramter
            this.$nextTick(() => {
                bus.$emit('test', x)
            });

            let menuParam = this.$route.params.menuId
            console.info('loading summary')
            this.menuName = this.$store.state.menuMasterData.filter(m => m.menuId === menuParam).map(m => m.menuName)[0]
            this.screenName = this.$store.state.menuMasterFlat.filter(m => m.menuId === submenuParam).map(m => m.menuName)[0]
            this.menusyspk = this.$store.state.menuMasterData.filter(m => m.menuId === menuParam).map(m => m.syspk)[0]
            console.log("Menu NAme",this.menuName);
            console.log("Screen NAme",this.screenName);

            for(var i=0; i<vizData.length ; i++){
                vizData[i]['f'] =x
                console.log("test time",this.time3[0]);
                vizData[i]['f']['fromDate']=this.time3[0]
                vizData[i]['f']['toDate']=this.time3[1]
                vizData[i]['fromDate']=this.time3[0] //work around
                vizData[i]['toDate']=this.time3[1] //work around
            }
            console.log("After appending LB",vizData);
            //what we'll do is identify the max rows
            //then for each row identify the max cols
            //let maxRows = _.max(vizData.map(v => v.positionRow)) + 1
            let maxRows = _.max(vizData.map(v => v.vizletSequence))
            console.log("Max Rows",maxRows);
            //this.rows = _.range(1, maxRows)
            this.rows = _.range(0,maxRows)
            // let kk = this.screenlet
            this.vizDataRowCol[this.screenlet] = vizData
            console.log("VizDataRowCol",this.vizDataRowCol)
            //log the event in audi log
            this.$commonFn.auditLog(this.menusyspk,submenuParam,this.menuName,this.screenName, "GET", "Success")
            //this.$commonFn.auditLog(this.menuName, this.screenName, "", "GET", "Success")
            //this.$refs.childComponent.loadViz()
            let dateFilter = {"d4l1_date":this.time3[0] }
            console.log("Date time range selection",this.time3,dateFilter);
        }, err => {
            console.error("error in getting he viz1 data", err)
        })*/
    },

    listenToRouter: function () {
      let $this = this

      this.$router.afterEach(function (from, to) {
        console.log(`router moved to ${from.path} from ${to.path}`)
        //$this.rows = []
        $this.screenListboxDim = {}
        $this.screenListboxCount = null
        $this.optionValues = []
        setTimeout(() => {
          $this.screenRender()
          $this.loadListbox()

          $this.loadSummary()
        }, 300)
      })
    }
  },
}
</script>
<style>


.card-true {
  height: 86vh;
  overflow: auto;
}

.card-false {
  height: 93vh;
}

.refresh {
  display: inline-block;
  transform: rotate(90deg);
}

.anyWhichWayS {
  background: #c7f0c3; /* #89fb85  daf0d9 */
}

.freeFormS {
  background: #91bbf0;
}
.card-deck{
  margin: 0px;
  .card{
    margin: 0;
  }
}

</style>